module.exports = __webpack_public_path__ + "static/media/labour_icon.9821fea9.svg";